import { createTheme } from "@mui/material/styles";
import { keyframes } from "@mui/system";

// Define keyframe animations
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateX(-100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

const theme = createTheme({
  palette: {
    primary: {
      main: "#2C3E50", // Deep Blue for sophistication
      contrastText: "#FFFFFF", // White for text on buttons and headers
    },
    secondary: {
      main: "#B8860B", // Muted Gold for subtle elegance
      contrastText: "#FFFFFF", // White for better readability
    },
    background: {
      default: "#F4F4F4", // Soft off-white for a clean background
      paper: "#FFFFFF", // White for cards and sections
    },
    text: {
      primary: "#2C3E50", // Deep Blue for main text
      secondary: "#7F8C8D", // Subtle gray for secondary text
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Poppins', sans-serif",
    h1: {
      fontSize: "2.8rem",
      fontWeight: 700,
      color: "#2C3E50", // Deep Blue for main headings
      "@media (max-width:600px)": {
        fontSize: "2.2rem",
      },
    },
    h2: {
      fontSize: "2.2rem",
      fontWeight: 600,
      color: "#B8860B", // Muted Gold for secondary headings
      "@media (max-width:600px)": {
        fontSize: "1.8rem",
      },
    },
    h3: {
      fontSize: "1.8rem",
      fontWeight: 500,
      color: "#2C3E50",
    },
    body1: {
      fontSize: "1rem",
      color: "#7F8C8D", // Subtle gray for body text
      lineHeight: 1.8,
    },
    button: {
      textTransform: "uppercase",
      fontWeight: 600,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#2C3E50", // Deep Blue header
          boxShadow: "none",
          padding: "0.8rem 0",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "50px",
          padding: "0.6rem 2rem",
          fontSize: "1rem",
          backgroundColor: "#B8860B", // Muted Gold for buttons
          color: "#FFFFFF",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.05)",
            backgroundColor: "#2C3E50", // Deep Blue on hover
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          animation: `${fadeIn} 0.8s ease`,
        },
      },
    },
  },
});

export default theme;
